<template>

    <div v-if="show" class="form_btn_container" id="form_btn_container">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <h3 style="color: var(--titulo);">{{ form_title }}:</h3>
            <div>
                <AppButton v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                    @close="close" :width=20 :height=20 />
            </div>
        </div>
        <div class="form_container">

            <div id="left_form" class="left_form">

                <div class="input_container">
                    <label for="codigo" class="input_label">artigo:</label>
                    <input style="color: var(--text); background-color: var(--label);" type="text"
                        v-model="formData.artigo" placeholder="Artigo" class="input_field"
                        :class="{ 'red-border': isEmptyField('artigo') }">
                </div>

                <div class="input_container">
                    <label for="artigo" class="input_label">codigo:</label>
                    <input style="color: var(--text); background-color: var(--label);" type="text"
                        v-model="formData.codigo_barras" placeholder="Codigo" class="input_field"
                        :class="{ 'red-border': isEmptyField('codigo_barras') }">
                </div>

                <div style="display: flex; ">
                    <label style="min-width: 7rem; color: var(--label);">Descriçao:</label>
                    <textarea v-model="formData.descricao" placeholder="Descrição" class="input_field textarea"
                        :class="{ 'red-border': isEmptyField('descricao') }"
                        style="resize: none; color: var(--text); background-color: var(--label);"></textarea>
                </div>



                <div class="data_set_class">
                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Tipo Artigo:
                        </div>

                        <div v-bind:style="{ color: set_data.tipo_artigo.id === 0 ? 'var(--obrigatorio)' : '#ff9b05' }">
                            {{ set_data.tipo_artigo.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Armazem:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.armazem.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Cliente:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.cliente.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Sub Cliente:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.sub_cliente.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Local:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.local.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Equipamento:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.equipamento.nome }}
                        </div>
                    </div>

                    <div class="data_set">
                        <div style="min-width: 142px;">
                            Serviço:
                        </div>

                        <div style="color: #ff9b05;">
                            {{ set_data.servico.nome }}
                        </div>
                    </div>

                </div>

            </div>

            <div id="right_form" class="right_form">
                <div class="img_container">
                    <div class="img_btn_container">
                        <div class="img_container">
                            <img id="artigo_img" src="@/assets/hard_hat.svg" alt="viatura image">
                        </div>

                        <div style="margin-top: 0.5rem;">
                            <label for="input-file">
                                <i class="fa-solid fa-circle-plus fa-xl" style="color: #ffffff; cursor: pointer;"></i>
                            </label>
                            <input type="file" accept="image/*" id="input-file" @change="upload_img" hidden>
                        </div>

                    </div>

                </div>

                <div style="display: flex; gap: 0.5rem; padding: 0rem; align-self: flex-start;">

                    <AppButton v-bind:visibility="true" :font_size="11" color="#ff9b05"
                        left_icon="fa-solid fa-pen-to-square" text="Tipo" emitType="select"
                        @select="selectTable('tipo')" />
                    <AppButton v-bind:visibility="true" :font_size="11" color="#ff9b05"
                        left_icon="fa-solid fa-pen-to-square" text="Armazem" emitType="select"
                        @select="selectTable('armazem')" />
                    <AppButton v-bind:visibility="true" :font_size="11" color="#ff9b05"
                        left_icon="fa-solid fa-pen-to-square" text="Cliente" emitType="select"
                        @select="selectTable('cliente')" />




                </div>
                <div style="display: flex; gap: 0.5rem; padding: 0rem; align-self: flex-start; ">
                    <AppButton v-bind:visibility="true" :font_size="11" color="#ff9b05"
                        left_icon="fa-solid fa-pen-to-square" text="Sub cliente" emitType="select"
                        @select="selectTable('sub_cliente')" />
                    <AppButton v-bind:visibility="true" :font_size="11" color="#9797EF"
                        left_icon="fa-solid fa-pen-to-square" text="Local" emitType="select"
                        @select="selectTable('local')" />
                    <AppButton v-bind:visibility="true" :font_size="11" color="#9797EF"
                        left_icon="fa-solid fa-pen-to-square" text="Equipamento" emitType="select"
                        @select="selectTable('equipamento')" />
                    <AppButton v-bind:visibility="true" :font_size="11" color="#9797EF"
                        left_icon="fa-solid fa-pen-to-square" text="Serviço" emitType="select"
                        @select="selectTable('servico')" />


                </div>

            </div>
        </div>
        <div style="display: flex; gap: 0.5rem; padding: 1rem;">

            <button v-if="create_btn" class="btn" @click="showConfirm($event, 'create')">Criar</button>
            <button v-if="!create_btn && update_visibility" class="btn"
                @click="showConfirm($event, 'update')">Atualizar</button>

            <AppButton :visibility="!create_btn && disable_visibility" :font_size="11" color="red"
                :text="form_data.status === 'ativo' ? 'Desativar' : 'Ativar'"
                @click="showConfirm($event, 'disable')" />
            <!-- <ConfirmPopup id="confirm" aria-label="popup" />

            <Button @click="openPopup($event)" label="Confirm" id="confirmButton" :aria-expanded="isVisible" :aria-controls="isVisible ? 'confirm' : null" /> -->

            <!-- <button @click="showConfirm($event, 'tipo')">Show Confirm</button>-->
            <ConfirmPopUp ref="myConfirm" @accept="onAccept" />

            <!-- <button @click="showConfirm($event, 'terminar')">Show Confirm</button> -->

        </div>
    </div>
</template>

<script>

import AppButton from '@/components/updated/button.vue';
import ConfirmPopUp from '@/components/modals/MyConfirmPopUp.vue';

export default {

    name: 'AppUserForm',
    components: {
        AppButton,
        ConfirmPopUp


    },
    props: {
        form_data: {
            type: Object,
            default: () => ({}),
        },
        set_data: {
            type: Object,
            default: () => ({}),
        },
        show: {
            type: Boolean,
            default: () => false,
        },
        form_title: {
            type: String,
            default: () => "No Title"

        },
        create_btn: {
            type: Boolean,
            default: () => false
        },
        update_visibility: {
            type: Boolean,
            default: () => false
        },
        disable_visibility: {
            type: Boolean,
            default: () => false
        }

    },

    data() {
        return {
            formData: {},
            emit_type: '',
        };
    },
    mounted() {
        // this.formData.tipo_utilizador = this.form_data.tipo_utilizador[0];
    },
    methods: {

        showConfirm(event, message) {
            this.emit_type = message;
            this.$refs.myConfirm.show(event.target);
        },
        onAccept() {
            if (this.emit_type == 'create') {

                this.create();
            }
            else if (this.emit_type == 'update') {
                this.update();
            }
            else if (this.emit_type == 'disable') {
                this.disable();
            }

            else {

                this.$emit('show_table', this.emit_type);
            }

            console.log('Confirmed!');
        },

        selectTable(name) {
            // Logic to handle selecting armazem
            console.log("select:", name)
            this.$emit('show_table', name);
        },

        upload_img(event) {
            console.log("inside upload method")
            const file = event.target.files[0];
            if (file) {

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = document.getElementById('artigo_img');
                    img.src = e.target.result;
                    this.formData.foto = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },

        create() {
            if (!this.isValidForm()) return
            console.log("valid form")
            const formData = this.getFormData();
            //console.log("create formdata:", formData)
            this.$emit('create', formData);

        },
        update() {
            if (!this.isValidForm()) return
            const formData = this.getFormData();
            //console.log("update formdata:", formData)
            this.$emit('update', formData);

        },


        disable() {
            //if(!this.isValidForm()) return
            const formData = this.getFormData();
            //console.log("disable formdata:", formData)
            this.$emit('disable', formData);

        },
        isValidForm() {

            if (!this.formData.codigo_barras || !this.formData.artigo ||
                !this.formData.descricao || (this.set_data.tipo_artigo.id == 0)
            ) {
                return false;
            }
            return true;
        },

        async create(data, url) {
            try {
                const res = await axios.post(url, data);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },


        getFormData() {

            const formDataObject = {
                ...this.formData,
                ...this.set_data
            };


            return formDataObject;
        },
        close() {
            this.$emit('close');
        },
        updateFormData() {

            this.formData = { ...this.form_data };
            console.log("form data:", this.formData)
        },
        isEmptyField(field) {

            if (["codigo_barras", "artigo", "descricao"].includes(field)) {

                return ((this.formData[field] === '') || Array.isArray(this.formData[field]));
            }

            return false;
        },


    },




    // setup() {
    //     const confirm = useConfirm();
    //     const isVisible = ref(false);

    //     const openPopup = (event) => {
    //         confirm.require({
    //             target: event.currentTarget,
    //             message: 'Are you sure you want to proceed?',
    //             header: 'Confirmation',
    //             acceptLabel: 'Yes',
    //             rejectLabel: 'No',
    //             accept: () => console.log('Accepted'),
    //             reject: () => console.log('Rejected'),
    //             onShow: () => isVisible.value = true,
    //             onHide: () => isVisible.value = false
    //         });
    //     }

    //     return {
    //         openPopup,
    //         isVisible
    //     };
    // },

    watch: {
        form_data: {
            handler() {

                this.updateFormData();
                //this.isEmptyContactField()
            },
            immediate: true,
            deep: true,
        },
    },


}
</script>



<style scoped>
@import 'primevue/resources/themes/aura-light-green/theme.css';
@import 'primevue/resources/themes/saga-blue/theme.css';
@import 'primevue/resources/primevue.min.css';
@import 'primeicons/primeicons.css';

.form_btn_container {

    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: var(--fundoForm);
    padding: 1rem;
}

.form_container {
    display: flex;
    gap: 2rem;
    padding: 1rem;
    border-radius: 10px;
}


.left_form {
    display: flex;
    flex-direction: column;
    /* gap: 0.2rem; */
    gap: 1rem;
}

h3 {
    display: flex;
    padding: 0.4rem;
    color: white;
}

label {
    display: block;
    color: white;
    /* font-weight: bold; */
    font-size: 14px;
    padding: 0.2rem;
    min-width: 1rem;
    text-wrap: nowrap;
}


input[type="text"],
input[type="password"],
select {
    /* width: 20px; */
    padding: 0.3rem;
    /* Reduce padding */
    font-size: 10px;
    /* Decrease font size */
    border-radius: 5px;
    border: 1px solid #cccccc;

}

.input_field.textarea {
    /* Define width and height as needed */
    width: 200px;
    height: 100px;
    /* Add other styles as needed */
}

.btn_div {
    color: white;
    display: flex;
    padding-left: 1rem;
    align-items: center;
    gap: 0.6rem;
}

.btn {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: rgb(0, 102, 152);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    gap: 0.5rem;
}

.data_set_class {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 10px;
    background-color: var(--fundoComponente);
}

.data_set {

    font-size: 14px;
    color: var(--label);
    display: flex;
    gap: 0.3rem;
}

.right_form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
    align-items: center;
    /* display: none; */

}

.img_container {
    margin-top: -0.5rem;
    /* margin-left: 3rem; */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
}

.img_btn_container {
    display: flex;
    gap: 0.5rem;
}

.img_container {
    display: flex;
    width: 150px;
    aspect-ratio: 1/1;
    height: auto;

}

.img_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}


.signature_container {
    display: flex;
    gap: 1rem;
}

.tpa_certificado_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.signature_div {
    display: flex;
    gap: 1rem;
}

.signature_field_container {
    display: flex;
    width: 100px;
    height: auto;
    background-color: #626288;
    border-radius: 0.2rem;
}

.signature_field_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.2rem;
}

.signature_icon_container {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding-top: 1rem;

}

.right_input_container {

    /* padding: 0.8rem; */
    margin-top: 0.5rem;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    /* border:1px solid white; */
    border-radius: 0.5rem;
    /* background-color: rgba(93, 93, 152, 0.55); */


}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
    display: flex;
    align-items: center;
    gap: 1rem;
    /* Adjust spacing between label and input field */
}

.input_label {
    width: 100px;
    /* Adjust label width as needed */
    color: var(--label);
    font-size: 14px;
}

.input_field {
    flex: 1;
    /* Take remaining space */
    padding: 0.3rem;
    font-size: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.rae_container {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-radius: 10px;
    padding: 1rem;
    background-color: rgba(93, 93, 152, 0.55);
}

.red-border {
    /* border: 1px solid red; */
    background-color: rgba(176, 88, 88, 0.664)
}
</style>
